// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3A4E2","buttons":"PendingPaymentAlert_buttons__lRV-z"};